import BlockContent from '@sanity/block-content-to-react'
import { Col, Layout, Row } from 'antd'
import React, { Fragment } from 'react'
import { withSiteData } from 'react-static'
import styled from 'styled-components'
import getSerializers from '../utils/sanitySerializers'

const StFooter = styled(Layout.Footer)`
  color: ${p => p.theme.textOffwhite};

  figure {
    margin: 20px 0;

    img {
      max-width: 100%;
    }
  }
`

class Footer extends React.Component {
  state = {}

  constructor(props) {
    super(props)
    this._serializers = getSerializers(props.siteData)

    delete this._serializers.types
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const colWidth = Math.floor((24 - 2) / nextProps.siteData.footer.length)
    return {
      innerColLayout: {
        xs: 24,
        sm: 24,
        md: colWidth * 2,
        lg: colWidth,
        xl: colWidth,
      },
    }
  }

  render() {
    const {
      siteData: { footer, bhnSites, sanityConfig },
      colLayout,
      ...props
    } = this.props

    const besthostingNetwork = (
      <Fragment>
        <h3>BestHosting Network</h3>
        <a href="https://www.besthosting.network">BestHosting Network</a>
        {bhnSites
          .filter(site => site.isLive)
          .map(site => (
            <Fragment key={site._id}>
              <br />
              <a href={site.url} target="_blank">
                {site.prettyName}
              </a>
            </Fragment>
          ))}
      </Fragment>
    )

    const textBlocks = footer.map(({ id, body }) => (
      <Col {...this.state.innerColLayout} key={id}>
        <BlockContent
          blocks={body}
          serializers={this._serializers}
          projectId={sanityConfig.projectId}
          dataset={sanityConfig.dataset}
        />
        {id === 'sitemap' && besthostingNetwork}
      </Col>
    ))

    return (
      <StFooter {...props}>
        <Row type="flex" justify="center">
          <Col {...colLayout}>
            <Row type="flex" justify="space-between">
              {textBlocks}
            </Row>
          </Col>
        </Row>
      </StFooter>
    )
  }
}

export default withSiteData(Footer)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/Footer.jsx